export interface DocumentLike {
    id: string;
    reference?: string | null;
    amendsDocumentId?: string | null;
}

/**
 * Identifies if a document is considered an "Originalfassung" (original version).
 * The current heuristic: reference ends with "_Originalfassung".
 */
export const isOriginalDocument = (doc: DocumentLike): boolean => {
    return !!doc.reference?.endsWith("_Originalfassung");
};

/**
 * Identifies if a document is considered an amendment (Änderungsdokument).
 * Heuristic: it references another document via `amendsDocumentId`.
 */
export const isAmendmentDocument = (doc: DocumentLike): boolean => {
    return !!doc.amendsDocumentId;
};

/**
 * Determines whether a document should be shown given the current user settings.
 * Main documents (neither original nor amendment) are always shown.
 */
export const isDocumentVisible = (
    doc: DocumentLike,
    opts: { showOriginals: boolean; showAmendments: boolean }
): boolean => {
    if (isOriginalDocument(doc)) return opts.showOriginals;
    if (isAmendmentDocument(doc)) return opts.showAmendments;
    return true;
}; 